import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getFilters } from '@/help.filters';
let FiltersBase = class FiltersBase extends Vue {
    constructor() {
        super(...arguments);
        this.filters = getFilters();
    }
    get filtersSelected() {
        return this.filters.reduce((arr, e, i) => {
            if (e.selected)
                arr.push(i);
            return arr;
        }, []);
    }
    get anyFiltersSelected() { return this.filtersSelected.length > 0; }
};
FiltersBase = tslib_1.__decorate([
    Component
], FiltersBase);
export default FiltersBase;
